export default __webpack_public_path__ + "20523381a742ca1d4a265751ab6b930c.ttf";